var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var tracking = require('js/lib/tracking');
var ModelManager = require('js/lib/models/ModelManager');

function ProductTracking(spin, location) {
  if(!spin){
    return {};
  }

  let product;
  
  if (location === "ItemPurchaseForm") {
    product = ModelManager.getProduct(spin);
  } 

  /**
   * Scrapes product data on page if data is not accessible in product object
   * @param product
   * @param location
   */
  const getDefaultFormData = function(product, location) {
    let formData = {};
    /* 
      location here is needed since how we capture each ecommerce
      event's data is heavily dependent on where it came from. For
      instance, 'gift card' only needs one querySelector to get the price
      while 'upload model' needs two.
    */

    if (location === 'ItemPurchaseForm') {
      const spin = product.get('spin');
      const price = product.get('shopperPrice');
      const material = product.get('shopperTitle');
      // Need to get this data from page if the user didnt update change fields which auto-updates the product model
      if (!price) {
        const priceEl = $(`[data-sw-product-price="${spin}"] [data-display-currency-component-value]`);
        formData.price = priceEl.text();
      }
      if (!material) {
        const materialEl = $(`[data-sw-material-selector="${spin}"] .sw-dropdown-icon img`);
        formData.material = materialEl.attr('title');
      }
    }

    return formData;
  };

  /*
  * returns event data to be sent to GA
  * @param eventName
  * @param eventData
  */
  const getProductData = function(eventName, eventData) {
    let productData;
    if (eventName === 'ecommerce_add_to_cart') {
      productData = tracking.getEventAddToCartData(
        Object.assign({spin: spin}, eventData),
        product
      );
    } else if (eventName === 'ecommerce_remove_from_cart') {
      productData = tracking.getEventRemoveFromCartData(
        Object.assign({spin: spin}, eventData)
      );
    } else if (eventName === 'ecommerce_product_detail') {
      productData = tracking.getEventProductDetailData(spin);
    } else if (eventName === 'ecommerce_product_click') {
      productData = tracking.getEventProductClickData(
          Object.assign({spin: spin}, eventData)
      );
    }

    if (!productData) {
      return null;
    }

    const data = {
      'ecommerce': productData,
    };

    return data;
  };

  return {
    /**
     * Tracks add to cart for product
     * @param extraData
     */
    trackAddProductToCart(eventData) {
      const eventName = 'ecommerce_add_to_cart';
      const extraFormData = getDefaultFormData(product, eventData.location);
      Object.assign(eventData, extraFormData);

      const data = getProductData(eventName, eventData);
      if (data) {
        sw.track(eventName, data, {trackingServices: ['dataLayer']});
      }
    },

    /**
     * Tracks remove from cart for product
     * @param extraData
     */
    trackRemoveProductFromCart(eventData) {
      const eventName = 'ecommerce_remove_from_cart';
      const data = getProductData(eventName, eventData);
      if (data) {
        sw.track(eventName, data, {trackingServices: ['dataLayer']});
          //remove the ga product data that represents the cart item that was removed
          let productId = spin + '-' + eventData.pconfId;
          sw.data.tracking.products = sw.data.tracking.products.filter(product => product.id !== productId);
      }
    },

    /**
     * Tracks product detail page impression
     */
    trackProductDetailImpression() {
      const eventName = 'ecommerce_product_detail';
      const data = getProductData(eventName);
      if (data) {
        sw.track(eventName, data, {trackingServices: ['dataLayer']});
      }
    },

    /**
     * Tracks product click event
     */
    trackProductClick(eventData) {
      const eventName = 'ecommerce_product_click';
      const data = getProductData(eventName, eventData);
      if (data) {
        sw.track(eventName, data, {trackingServices: ['dataLayer']});
      }
    },
  };
}


var _gaq = window._gaq = window._gaq || [];

if (sw.data.shopTrackingCode && (sw.data.pageIdentifier === 'product-view')) {
  _gaq.push(['b._setAccount', window.sw.data.shopTrackingCode]);
  _gaq.push(['b._trackPageview']);
}

// all product detail pages
if (sw.data.pageIdentifier === 'product-view') {
  const productIds = Object.keys(sw.data.products);
  /*
  *  check if there are any products
  *  theres only one product on the product detail page
  *  which is the product to track
  */
  if (productIds.length > 0) {
    const spin = productIds[0];
    const productTracking = ProductTracking(spin, "ProductDetail");
    productTracking.trackProductDetailImpression();
  }
}


// sw.on('cart-add-product', function(fragment, spin, eventData){
//   const productTracking = ProductTracking(spin, eventData.location);
//   productTracking.trackAddProductToCart(eventData);
// });

sw.on('cart-remove-product', function(spin, eventData){
  const productTracking = ProductTracking(spin, eventData.location);
  productTracking.trackRemoveProductFromCart(eventData);
});


module.exports = {
  ProductTracking: ProductTracking
};
